import { createMuiTheme } from "@material-ui/core";

import colors from "../../shared-styles/colors";

const playgroundTheme = createMuiTheme({
  /** Set default props for Material UI components  */
  props: {
    MuiTextField: {
      variant: "outlined"
    },
    MuiButton: {
      variant: "contained",
      disableElevation: true,
      color: "primary"
    }
  },
  /** Set a custom color palette */
  palette: {
    primary: { main: colors.lightBlue },
    secondary: { main: colors.accentYellow },
    background: {
      default: colors.deepBlue0,
      paper: colors.deepBlue2
    },
    text: {
      primary: colors.white9,
      secondary: colors.white7,
      disabled: colors.white5,
      hint: colors.white7
    }
  },
  shape: {
    borderRadius: 2
  },

  /** Set custom typography used throughout the theme
   *  We should stick to these font variants as much as possible throughout
   *  the app and not have a bunch of custom font sizes
   */
  typography: {
    h6: {
      fontWeight: "bolder",
      fontSize: "1rem"
    }
  },

  /** Override styles for every Material UI component that is a child of
   *  the ThemeProvider */
  overrides: {
    MuiButton: {
      root: {
        fontWeight: "bolder",
        textTransform: "none"
      },
      outlinedPrimary: {
        color: colors.white9,
        border: `2px solid ${colors.lightBlue}`,
        "&:hover": {
          border: `2px solid ${colors.lightBlue}`
        }
      },
      outlinedSecondary: {
        color: colors.white9,
        border: `2px solid ${colors.accentYellow}`,
        "&:hover": {
          border: `2px solid ${colors.accentYellow}`
        }
      }
    },
    MuiTextField: {
      root: {
        backgroundColor: colors.deepBlue0
      }
    }
  }
});

export default playgroundTheme;
